import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { CoverSlide } from './components/CoverSlide';
import { IndexSlide } from './components/IndexSlide';
import { ProblemSlide } from './components/ProblemSlide';
import { SolutionSlide } from './components/SolutionSlide';
import { Phase1Slide } from './components/Phase1Slide';
import { ArchitectureSlide } from './components/ArchitectureSlide';
import { OnboardingSlide } from './components/OnboardingSlide';
import { MotorcycleSlide } from './components/MotorcycleSlide';
import { CoreModulesSlide } from './components/CoreModulesSlide';
import { AdvancedModulesSlide } from './components/AdvancedModulesSlide';
import { ControlSlide } from './components/ControlSlide';
import { Phase2Slide } from './components/Phase2Slide';
import { ImpactSlide } from './components/ImpactSlide';
import { RoadmapSlide } from './components/RoadmapSlide';
import { DemoSlide } from './components/DemoSlide';
import { ThankYouSlide } from './components/ThankYouSlide';
export function App() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [<CoverSlide key="0" data-id="element-0" />, <IndexSlide key="1" data-id="element-1" />, <ProblemSlide key="2" data-id="element-2" />, <SolutionSlide key="3" data-id="element-3" />, <Phase1Slide key="4" data-id="element-4" />, <ArchitectureSlide key="5" data-id="element-5" />, <OnboardingSlide key="6" data-id="element-6" />, <MotorcycleSlide key="7" data-id="element-7" />, <CoreModulesSlide key="8" data-id="element-8" />, <AdvancedModulesSlide key="9" data-id="element-9" />, <ControlSlide key="10" data-id="element-10" />, <Phase2Slide key="11" data-id="element-11" />, <ImpactSlide key="12" data-id="element-12" />, <RoadmapSlide key="13" data-id="element-13" />, <DemoSlide key="14" data-id="element-14" />, <ThankYouSlide key="15" data-id="element-15" />];
  const totalSlides = slides.length;
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % totalSlides);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + totalSlides) % totalSlides);
  };
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'ArrowRight') {
        nextSlide();
      } else if (e.key === 'ArrowLeft') {
        prevSlide();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [totalSlides]);
  const slideNumber = String(currentSlide + 1).padStart(2, '0');
  const totalFormatted = String(totalSlides).padStart(2, '0');
  return <div className="relative w-screen h-screen overflow-hidden bg-white" data-id="element-16">
      {/* Current Slide */}
      {slides[currentSlide]}

      {/* Slide Number Overlay (top-right) */}
      <div className="fixed top-6 right-8 z-50" data-id="element-17">
        <span className="text-gray-400 font-medium text-sm tracking-widest" data-id="element-18">
          {slideNumber} / {totalFormatted}
        </span>
      </div>

      {/* Navigation Overlay */}
      <div className="fixed bottom-2 right-4 flex items-center gap-4 bg-white/80 hover:bg-white/95 transition-colors backdrop-blur-sm px-4 py-1.5 rounded-full z-50 shadow-sm border border-gray-200/50" data-id="element-19">
        <button onClick={prevSlide} className="p-1 text-gray-500 hover:text-gray-800 transition-colors disabled:opacity-30" disabled={currentSlide === 0} aria-label="Previous slide" data-id="element-20">
          <ChevronLeft className="w-5 h-5" data-id="element-21" />
        </button>

        <div className="flex items-center gap-2" data-id="element-22">
          {slides.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-2 h-2 rounded-full transition-all ${currentSlide === index ? 'bg-gray-800 w-4' : 'bg-gray-400 hover:bg-gray-600'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-23" />)}
        </div>

        <button onClick={nextSlide} className="p-1 text-gray-500 hover:text-gray-800 transition-colors disabled:opacity-30" disabled={currentSlide === totalSlides - 1} aria-label="Next slide" data-id="element-24">
          <ChevronRight className="w-5 h-5" data-id="element-25" />
        </button>
      </div>
    </div>;
}